import axios from "axios";
import { toast } from "sonner";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        const status = error.response?.status;

        if (status === 401) {
            window.location.href = "/login";
            return Promise.reject(error);
        }

        if (status === 419) {
            toast.error("Your session has expired. Reloading the page...");
            window.location.reload();
            return Promise.reject(error);
        }

        if (!error.response) {
            toast.error(
                "A network error occurred. Please check your connection and try again.",
            );
        } else if (status === 500) {
            toast.error("Something went wrong on our end. Please try again later.");
        } else if (status === 503) {
            toast.error("The service is temporarily unavailable. Please try again later.");
        } else if (status === 429) {
            toast.error("Too many requests. Please wait a moment and try again.");
        } else if (status && status >= 500) {
            toast.error("A server error occurred. Please try again later.");
        }

        error._handled = true;

        return Promise.reject(error);
    },
);
